import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'PressPage',
  setup(__props) {

const podcastCoverJpg = `/${ASSETS_DIR}/img/press/podcast-cover.jpg`;
const podcastCoverWebp = `/${ASSETS_DIR}/img/press/podcast-cover.webp`;

return { __sfc: true,podcastCoverJpg, podcastCoverWebp }
}

})